module.exports = __webpack_public_path__ + "media/images/logo_black-f7c49a234c9a9fd8b0baba6b79701032.svg";